export default "__VITE_ASSET__1f7aada8__"